import { render, staticRenderFns } from "./DeploymentList.vue?vue&type=template&id=11674464&scoped=true&"
import script from "./DeploymentList.vue?vue&type=script&lang=js&"
export * from "./DeploymentList.vue?vue&type=script&lang=js&"
import style0 from "./DeploymentList.vue?vue&type=style&index=0&id=11674464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11674464",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VChip,VCol,VRow,VSheet})
